import { useCallback, useMemo } from 'react';
import { toast } from 'sonner';

export function useCartActions(setState) {
  // ---------- Cart ----------
  const addToCart = useCallback((product, qty = 1, variant = null) => {
    setState((s) => {
      const existing = s.cart.find((c) => c.productId === product.id && c.variant === variant);
      const cart = existing
        ? s.cart.map((c) => (c === existing ? { ...c, qty: c.qty + qty } : c))
        : [...s.cart, { productId: product.id, variant, qty, selected: true }];
      return { ...s, cart };
    });
    toast.success('Added to cart', { description: product.name });
  }, []);

  const updateCartQty = useCallback((productId, variant, qty) => {
    setState((s) => ({
      ...s,
      cart: qty <= 0
        ? s.cart.filter((c) => !(c.productId === productId && c.variant === variant))
        : s.cart.map((c) => (c.productId === productId && c.variant === variant ? { ...c, qty } : c)),
    }));
  }, []);

  const toggleCartItem = useCallback((productId, variant) => {
    setState((s) => ({ ...s, cart: s.cart.map((c) => (c.productId === productId && c.variant === variant ? { ...c, selected: !c.selected } : c)) }));
  }, []);

  const toggleCartMerchant = useCallback((merchantId, selected) => {
    setState((s) => ({ ...s, cart: s.cart.map((c) => (s.customProducts.find((p) => p.id === c.productId)?.merchantId === merchantId ? { ...c, selected } : c)) }));
  }, []);

  const removeCartItem = useCallback((productId, variant) => {
    setState((s) => ({ ...s, cart: s.cart.filter((c) => !(c.productId === productId && c.variant === variant)) }));
  }, []);

  // ---------- Favourites / Follows ----------
  const toggleFavourite = useCallback((productId) => {
    setState((s) => ({ ...s, favourites: s.favourites.includes(productId) ? s.favourites.filter((f) => f !== productId) : [...s.favourites, productId] }));
  }, []);

  const toggleFollow = useCallback((merchantId) => {
    setState((s) => ({ ...s, follows: s.follows.includes(merchantId) ? s.follows.filter((f) => f !== merchantId) : [...s.follows, merchantId] }));
  }, []);

  const markViewed = useCallback((productId) => {
    setState((s) => ({ ...s, recentlyViewed: [productId, ...s.recentlyViewed.filter((p) => p !== productId)].slice(0, 8) }));
  }, []);
  return useMemo(() => ({ addToCart, updateCartQty, toggleCartItem, toggleCartMerchant, removeCartItem, toggleFavourite, toggleFollow, markViewed }),
    [addToCart, updateCartQty, toggleCartItem, toggleCartMerchant, removeCartItem, toggleFavourite, toggleFollow, markViewed]);
}
